import React from "react";

import { NavLink } from "react-router-dom";
const Card = (props) => {
  return (
    
    
              <div className="col-10 col-md-4 mx-auto">
                <div class="card p-2">
                  <img src={props.imgsrc} class="card-img-top" alt="..." />
                  <div class="card-body">
                    {/* <h5 class="card-title">Card title</h5> */}
                    <h6 class="card-text">
                     {props.title}
                    </h6>
                    <NavLink to={props.paths} class="btn btn-primary m-2 p-2" style={{borderRadius:"30px"}}>
                      Check Details
                    </NavLink>
                  </div>
                </div>
              </div>
          
  );
};

export default Card;
